// extracted by mini-css-extract-plugin
export default {"pageWrap":"Cc-z","fullWidth":"Dc-z","heading":"Ec-z","fullBleed":"Fc-z","hidden":"Gc-z"};